export class ReasonError extends Error {
    readonly code: string;

    constructor(code: string, message: string) {
        super(message);
        this.name = 'ReasonError';
        this.code = code;
    }
}

export const reasonCodeOf = (error: unknown): string | null =>
    error instanceof ReasonError ? error.code : null;
